import React from "react";
import { Modal } from "../../../../../../../shared/Modal/Modal";
import { Button } from "../../../../../../../shared/Button/Button";
import { useActivateSmartReaderCellular } from "../hooks/useActivateSmartReaderCellular";
import { useDeactivateSmartReaderCellular } from "../hooks/useDeactivateSmartReaderCellular";
import { CircularProgress } from "../../../../../../../shared/CircularProgress/CircularProgress";
import { uiNotification } from "../../../../../../../services/UINotificationService";

const CellularCapabilityConfirmationModal = ({
  onClose,
  isCurrentlyActive,
  deviceId,
  refetch,
}) => {
  const { mutate: activateCellular, isLoading: isActivating } =
    useActivateSmartReaderCellular();
  const { mutate: deactivateCellular, isLoading: isDeactivating } =
    useDeactivateSmartReaderCellular();

  const isLoading = isActivating || isDeactivating;

  const handleSubmit = () => {
    const dto = { pos_device_id: deviceId };
    const submitter = isCurrentlyActive ? deactivateCellular : activateCellular;

    submitter(dto, {
      onSuccess: () => {
        onClose();
        refetch();
      },
      onError: () => {
        uiNotification.error(
          `Failed to ${
            isCurrentlyActive ? "deactivate" : "activate"
          } cellular option. Please try again.`,
        );
      },
    });
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      header={<h3>Confirm Action</h3>}
      footer={
        <div className="flex justify-end gap-16">
          <Button
            onClick={onClose}
            variant="outlined"
            size="small"
            isDisabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            size="small"
            onClick={handleSubmit}
            isDisabled={isLoading}
            leftAdornment={
              isLoading ? <CircularProgress color="white" size="small" /> : null
            }
          >
            Confirm
          </Button>
        </div>
      }
    >
      Are you sure you want to {isCurrentlyActive ? "deactivate" : "activate"}{" "}
      cellular option for this device?
    </Modal>
  );
};

export default CellularCapabilityConfirmationModal;
